if ($('.blog-single-product__scroll-wrapper').length) {
    if ($(window).innerWidth() > 1024) {
        $('.blog-single-product__scroll-wrapper').css({
            'width': $('.blog-single-product').width() + 'px'
        });
    }
    

    $(window).on('resize', function () {
        if ($(window).innerWidth() > 1024) {
            $('.blog-single-product__scroll-wrapper').css({
                'width': $('.blog-single-product').width() + 'px'
            });
        } else {
            $('.blog-single-product__scroll-wrapper').css({
                'width': 'auto'
            });
        }
    });

    
        $(window).on('scroll resize', function () {
            if ($(window).innerWidth() > 1024) {
                var offsetHeight = $(window).scrollTop() + 80 - $('.bor_head').height();

                if ($(window).scrollTop() > ($('.entry-content ').offset().top - $('.bor_head').height())) {
                    $('.blog-single-product__scroll-wrapper').css({
                        'position': 'fixed',
                        'top': $('.bor_head').height() + 20,
                        'bottom' : 'auto'
                    });

                    if (($('.blog-single-product__scroll-wrapper').offset().top + 20 + $('.blog-single-product__scroll-wrapper').height() - $('.entry-content').offset().top) > $('.entry-content').height()) {
                        $('.blog-single-product__scroll-wrapper').css({
                            'position' : 'absolute',
                            'top': 'auto',
                            'bottom' : 0
                        });
                    }
                } else {
                    $('.blog-single-product__scroll-wrapper').css({
                        'position': 'static',
                        'top': 'auto',
                    });
                }
            } else {
                $('.blog-single-product__scroll-wrapper').css({
                    'position': 'static',
                    'top': 'auto',
                });
            }
        });
}

if ($('#order_review').length) {
    if ($(window).innerWidth() > 768) {
        $('.order_review_float, #order_review').css({
            'width': ($('form.checkout').width() / 2) - 20 + 'px'
        });
        $('#customer_details').css({
            'width': ($('form.checkout').width() / 2) - 20 + 'px'
        });
    }

    $(window).on('resize', function () {
        if ($(window).innerWidth() > 768) {

            $('#customer_details').css({
                'width': ($('form.checkout').width() / 2) - 20 + 'px'
            });

            $('#order_review').css({
                'width': ($('form.checkout').width() - $('#customer_details').width()) - 20 + 'px'
            });

            $('.order_review_float').css({
                'width': $('#order_review').width() + 'px'
            });
        } else {
            $('.order_review_float, #order_review, #customer_details').css({
                'width': 'auto'
            });
        }
    });
    if ($(window).innerWidth() > 768) {
        $(window).on('scroll resize', function () {
            var offsetHeight = $(window).scrollTop() + 80 - $('.bor_head').height();

            if ($(window).scrollTop() > ($('#customer_details').offset().top - 20 - $('.bor_head').height())) {

                $('.order_review_float').css({
                    'position': 'fixed',
                    'top': $('.bor_head').height() + 20,
                    'bottom': 'auto'
                });

                if (($('.order_review_float').offset().top + $('.order_review_float').height() - $('form.checkout').offset().top) > $('form.checkout').height()) {
                    $('.order_review_float').css({
                        'position': 'absolute',
                        'top': 'auto',
                        'bottom': 0
                    });
                }
            } else {
                $('.order_review_float').css({
                    'position': 'static',
                    'top': 'auto',
                });
            }
        });
    } else {
        $('.order_review_float').css({
            'position': 'static',
            'top': 'auto',
        });
    }
}